import { experience } from "../../data/resume";

function Experience() {
    return (
        <section id="experience" className="section section-alt">
            <div className="container">
                <div className="section-header">
                    <p className="section-eyebrow">Where I've been</p>
                    <h2 className="section-title">Professional Experience</h2>
                </div>
                <div className="timeline">
                    {experience.map((role) => (
                        <div className="timeline-item" key={role.company}>
                            <div className="timeline-dot" />
                            <div className="timeline-content">
                                <span className="timeline-time">{role.time}</span>
                                <h3>{role.company}</h3>
                                <p>{role.role}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Experience;
